import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import OutletSection from '../components/OutletSection';
import OpeningAnnouncementSection from '../components/OpeningAnnouncementSection';
import SignatureDishesSection from '../components/SignatureDishesSection';
import MargaritaBarSection from '../components/MargaritaBarSection';
import SocialMediaSection from '../components/SocialMediaSection';

const HomePage = () => {
  return (
    <Layout>
      <SEO
        title="Casa Loco | Best Mexican Restaurant & Margarita Bar in Hyderabad"
        description="Craving authentic Mexican street food? Visit Casa Loco at Gachibowli, Hyderabad. Enjoy the best tacos, burritos, and signature Margaritas at our premium Margarita bar."
        path="/"
      />
      <HeroSection />
      <OutletSection />
      <OpeningAnnouncementSection />
      <SignatureDishesSection />
      <MargaritaBarSection />
      <SocialMediaSection />
    </Layout>
  );
};

export default HomePage;